import { Alignment, ValueType } from '../FormatterTypes';

/**
 * Base class that implement default behaviour for all displayers
 */
abstract class BaseDisplayer {
  protected constructor() {}
  abstract defaultParams(): string;
  abstract display(
    value: ValueType,
    displayText?: boolean,
    params?: string
  ): string;

  // Behövs dom här 3 metoderna? Ej implementerade i basklasser
  defaultDisplayLength(params: string = ''): number {
    return 0;
  }
  alignment(params: string = ''): Alignment {
    return 'taLeftJustify';
  }
  preDisplay(
    value: ValueType,
    displayText: boolean = true,
    params: string = ''
  ): string {
    return '';
  }
}

export { BaseDisplayer };
